import type { RouteRecordRaw } from 'vue-router'
const websiteRoutes: RouteRecordRaw = {
  path: '/website', name: 'Website', redirect: '/website/page',
  meta: { title: '官网商城', icon: 'icon-language' },
  children: [
    { path: 'page', name: 'WebPage', component: () => import('@/views/website/PageList.vue'), meta: { title: '页面管理' } },
    { path: 'product', name: 'WebProduct', component: () => import('@/views/website/ProductList.vue'), meta: { title: '商品展示' } },
    { path: 'blog', name: 'Blog', component: () => import('@/views/website/BlogList.vue'), meta: { title: '博客文章' } },
  ],
}
export default websiteRoutes
